export interface RouteEntry {
	path: string;
	text: string;
	helpContext?: string;
	parent?: string;
}

const config = {
	ROOT: { path: '/', text: 'Home' },
	HOME: { path: '/home', text: 'Home', helpContext: 'overview' },
	DASHBOARD: { path: '/dashboard', text: 'Dashboard', helpContext: 'overview' },
	FIND_ENTITY: { path: '/findEntity', text: 'Find Entity', helpContext: 'search' },
	FIND_CYCLE: { path: '/findCycle', text: 'Find Cycle', helpContext: 'search' },
	ENTITY_SEARCH: { path: '/entitySearch', text: 'Entity Search', helpContext: 'search' },
	CONTACT: { path: '/contact', text: 'Contact', helpContext: 'troubleshooting' },
	CHANGES: { path: '/changes', text: "What's New", helpContext: 'overview' },

	MANAGE_WORKFLOWS: { path: '/manageWorkflows', text: 'Manage Workflows', helpContext: 'workflows' },
	CREATE_WORKFLOW: { path: '/createWorkflow', text: 'Create Workflow', helpContext: 'workflows', parent: '/manageWorkflows' },
	VIEW_WORKFLOW: { path: '/viewWorkflow', text: 'View Workflow', helpContext: 'workflows', parent: '/manageWorkflows' },
	EXECUTE_WORKFLOWS: { path: '/executeWorkflows', text: 'Execute Workflows', helpContext: 'executeWorkflows' },
	REQUIREMENT_PAGE: { path: '/executeWorkflow/:workflowType', text: 'Submit And Execute', helpContext: 'executeWorkflows', parent: '/executeWorkflows' },
	BULK_EXECUTION: { path: '/bulkExecution/:workflowType', text: 'Bulk Execution', helpContext: 'executeWorkflows', parent: '/executeWorkflows' },
	LAYOUT_EDITOR: { path: '/layoutEditor', text: 'Layout Editor', helpContext: 'layoutEditor', parent: '/manageWorkflows' },
	WORKFLOW_DASHBOARD: { path: '/manageWorkflows/workflowDashboard', text: 'Workflow Dashboard', helpContext: 'workflows', parent: '/manageWorkflows' },
	SIMULATE_WORKFLOW: { path: '/simulateWorkflow', text: 'Simulate Workflow', helpContext: 'workflows', parent: '/manageWorkflows' },

	TASK_DASHBOARD: { path: '/taskDashboard', text: 'Task Dashboard'},
	NODE_NAME_VALIDATOR: { path: '/nodeNameValidator', text: 'Node Name Validator'},
	APPLICATION_MANAGEMENT: { path: '/applicationManagement', text: 'Application Management', helpContext: 'serviceRegistry' },
	ATTRIBUTE_MANAGEMENT: { path: '/attributeManagement', text: 'Attribute Management', helpContext: 'attributeManagement' },
	SUPPORTED_TASK_TYPES: { path: '/supportedTaskTypes', text: 'Supported Task Types', parent: '/applicationManagement' },
	ALERT_NODES_DASHBOARD: { path: '/alertNodesDashboard', text: 'Alert Nodes Dashboard', helpContext: 'overview' },

	TASK_ONBOARDING: { path: '/taskOnboarding', text: 'Task Onboarding', helpContext: 'overview' },
	WORKFLOW_CREATION_CANVAS: { path: '/workflowCreationCanvas', text: 'Workflow Creation Canvas', helpContext: 'workflows' },
	REQUIREMENTS_PAGE: { path: '/requirementsPage', text: 'Requirements', helpContext: 'executeWorkflows' },
	TEST_WF: { path: '/testWF', text: 'Test Workflow', helpContext: 'workflows' },

	APP_CONFIG_REVIEW_DASHBOARD: { path: '/appConfig', text: 'App Config Dashboard', helpContext: 'overview' },
	LIST_REVIEWS: { path: '/appConfig/listReviews', text: 'List Reviews', helpContext: 'overview', parent: '/appConfig' },
	VIEW_REVIEW: { path: '/appConfig/viewReviews', text: 'View Review', helpContext: 'overview', parent: '/appConfig' },
	VIEW_HOSTED_CONFIG: { path: '/appConfig/viewHostedConfig', text: 'View Hosted Config', helpContext: 'overview', parent: '/appConfig' },
	ONBOARD_SERVICE: { path: '/appConfig/onboardPodDetails', text: 'Onboard Service', helpContext: 'overview', parent: '/appConfig' },
	FC_TO_POD_MAPPINGS_DASHBOARD: { path: '/appConfig/fcToPodMapping', text: 'FC to Pod Mappings', helpContext: 'overview', parent: '/appConfig' },

	PRE_LAUNCH_WORKFLOW: { path: '/preLaunchWorkflow', text: 'Pre-Launch Workflow', helpContext: 'executeWorkflows' },
	LAUNCH_P2R_WORKFLOW: { path: '/launchP2RWorkflow', text: 'P2R Workflow', helpContext: 'executeWorkflows' },
	LAUNCH_RAD_WORKFLOW: { path: '/launchRadWorkflow', text: 'RAD Workflow', helpContext: 'executeWorkflows' },
	LAUNCH_NEW_STACK: { path: '/launchNewStack', text: 'Resilience Workflow', helpContext: 'executeWorkflows' },
	LAUNCH_DOCKMASTER_WORKFLOW: { path: '/launchDockmasterWorkflow', text: 'Dockmaster Workflow', helpContext: 'executeWorkflows' },
	LAUNCH_SORTER_WORKFLOW: { path: '/launchSorterWorkflow', text: 'Sorter Setup', helpContext: 'executeWorkflows' },
	LAUNCH_SORTER_WORKFLOW_EXECUTE: { path: '/launchSorterWorkflow/execute', text: 'Sorter Setup Execute', helpContext: 'executeWorkflows', parent: '/launchSorterWorkflow' },
	LAUNCH_FC_RECONFIG: { path: '/launchFCReconfig', text: 'FC Reconfig', helpContext: 'executeWorkflows' },
	LAUNCH_FC_RECONFIG_NODE_DETAILS: { path: '/launchFCReconfigNodeDetails', text: 'FC Reconfig Node Details', helpContext: 'executeWorkflows', parent: '/launchFCReconfig' },
	LAUNCH_NODE_ADDRESS_UPDATE_WORKFLOW: { path: '/launchNodeAddressUpdateWorkflow', text: 'Node Address Update', helpContext: 'executeWorkflows' },
	LAUNCH_NODE_ADDRESS_UPDATE_WORKFLOW_DETAILS: { path: '/launchNodeAddressUpdateWorkflowDetails', text: 'Node Address Update Details', helpContext: 'executeWorkflows', parent: '/launchNodeAddressUpdateWorkflow' },
	LAUNCH_ANCHOR_POINT_WORKFLOW: { path: '/launchAnchorPointWorkflow', text: 'Anchor Point', helpContext: 'executeWorkflows' },
	DELETE_ANCHOR_POINT_WORKFLOW: { path: '/deleteAnchorPointWorkflow', text: 'Delete Anchor Point', helpContext: 'executeWorkflows' },

	MANAGE_EXECUTION: { path: '/manageExecution', text: 'Manage Executions', helpContext: 'manageExecutions' },
	START_EXECUTION: { path: '/startExecution', text: 'Start Execution', helpContext: 'manageExecutions', parent: '/manageExecution' },

	SUB_TASK_CONFIGURATION: { path: '/taskConfiguration', text: 'SubTask Configuration' },
	CHAT_BOT: { path: '/chat', text: 'Chat' },

	COMPARE_WORKFLOWS: { path: '/compareWorkflows', text: 'Compare Workflows', helpContext: 'workflows', parent: '/manageWorkflows' },

	NOTIFICATION_MANAGER: { path: '/notificationManager', text: 'Notification Manager' },
	VIEW_NOTIFICATIONS: { path: '/viewNotifications', text: 'View Notifications' },
} as const satisfies Record<string, RouteEntry>;

export const ROUTE_CONFIG = config;

type RoutePaths = { [K in keyof typeof config]: (typeof config)[K]['path'] };
export const ROUTES: RoutePaths = Object.fromEntries(
	Object.entries(config).map(([key, entry]) => [key, entry.path])
) as RoutePaths;

const stripParams = (path: string): string => path.replace(/\/:[^/]+/g, '');

export const ROUTE_CONFIG_BY_PATH: Record<string, RouteEntry> = Object.fromEntries(
	(Object.values(config) as RouteEntry[]).map((entry) => [stripParams(entry.path), entry])
);
